import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { ReportCategoryCreateEditData } from './report-category-create-edit-data';
import { ReportCategory } from './report-category';
import { Observable } from 'rxjs';
import { IdentityService } from '../../../services/identity.service';
import { environment } from '../../../../environments/environment';
import { ServerPaginationParams } from '../../../interfaces/server-pagination-params';
import { PaginationService } from '../../../services/pagination.service';
import { map } from 'rxjs/operators';
import { ServerPaginatedData } from '../../../interfaces/server-paginated-data';
import { TeamReportCategory } from '../../teams/models/team-report-category';

@Injectable({
  providedIn: 'root',
})
export class ReportCategoriesService {
  readonly defaultPaginationOptions: ServerPaginationParams = {
    offset: 0,
    limit: 50,
    orderBy: 'CreatedAtUtc',
    desc: true,
  };

  private http = inject(HttpClient);
  private identityService = inject(IdentityService);
  private paginationService = inject(PaginationService);

  getReportCategories$(options: ServerPaginationParams): Observable<ServerPaginatedData> {
    const params = this.paginationService.getRequestParams(options);
    let httpParams = new HttpParams();

    params.forEach((value, key) => {
      httpParams = httpParams.set(key, value);
    });

    return this.http
      .get<ReportCategory[]>(`${environment.adminApi}/companies/${this.identityService.companySlug}/field-reports/categories`, {
        params: httpParams,
        observe: 'response',
      })
      .pipe(
        map((data: HttpResponse<any>) => {
          return { totalCount: data.headers.get('TotalCount'), body: data.body };
        }),
      );
  }

  createCategory(createData: ReportCategoryCreateEditData): Observable<ReportCategory> {
    return this.http.post<ReportCategory>(
      `${environment.adminApi}/companies/${this.identityService.companySlug}/field-reports/categories`,
      createData,
    );
  }

  updateCategory(updateData: ReportCategoryCreateEditData, id: string): Observable<ReportCategory> {
    return this.http.put<ReportCategory>(
      `${environment.adminApi}/companies/${this.identityService.companySlug}/field-reports/categories/${id}`,
      updateData,
    );
  }

  updateOrder(OrderedIds: string[]): Observable<unknown> {
    return this.http.put(`${environment.adminApi}/companies/${this.identityService.companySlug}/field-reports/categories/order`, {
      OrderedIds,
    });
  }

  deleteCategories(ids: string[]): Observable<unknown> {
    const params = ids.reduce((acc, id) => acc.append('Ids', id), new HttpParams());

    return this.http.delete(`${environment.adminApi}/companies/${this.identityService.companySlug}/field-reports/categories`, { params });
  }

  getReportCategoriesForTeam(): Observable<TeamReportCategory[]> {
    return this.http.get<TeamReportCategory[]>(
      `${environment.adminApi}/companies/${this.identityService.companySlug}/teams/field-reports/categories`,
    );
  }
}
